/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-plus': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M18 9a1 1 0 01-1 1h-7v7a1 1 0 01-2 0v-7H1a1 1 0 010-2h7V1a1 1 0 012 0v7h7a1 1 0 011 1z"/>'
  }
})
